module.exports = __webpack_public_path__ + "img/shitingfuzhuyongpin_shrz.d0917551.png";